<template>
  <div class="download-files">
    <download-file-card :name="name" :icon="icon" @click.native="onClick" />
    <ets-popup v-if="isPopupVisible" :title="`Ficheros del periodo ${name}`" hide-footer @close="isPopupVisible = false">
      <download-file-card
        v-for="(file, i) in files"
        :key="i"
        :name="getExtension(file.name)"
        :icon="getFileIcon(file.name)"
        @click.native="downloadFile(file)"
      />
    </ets-popup>
  </div>
</template>

<script>
import axios from "axios";
import FileLoader from "@/logic/utils/fileLoader";
import DownloadFileCard from "@/components/Download/DownloadFileCard";

const extensions = {
  xml: {
    options: {
      headers: {
        Accept: "application/xml"
      }
    },
    type: "application/xml",
    icon: "file-xml"
  },
  xlsx: {
    options: {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    },
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: "file-excel"
  }
};

export default {
  name: "DownloadFiles",
  components: {
    DownloadFileCard
  },
  props: {
    name: {
      type: String,
      required: true
    },
    files: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    isPopupVisible: false
  }),
  computed: {
    icon() {
      return this.files.length === 1 ? this.getFileIcon(this.files[0].name) : "download";
    }
  },
  methods: {
    getExtension(name) {
      const matched = name.match(/\.([0-9a-z]+)$/i);
      if (matched) return matched[1];
    },
    getOptions(name) {
      const extension = this.getExtension(name);
      return extensions[extension]?.options || {};
    },
    getFileType(name) {
      const extension = this.getExtension(name);
      return extensions[extension]?.type || "text";
    },
    getFileIcon(name) {
      const extension = this.getExtension(name);
      return extensions[extension]?.icon || "download";
    },
    async downloadFile(file) {
      const data = await axios.get(file.url, this.getOptions(file.name));
      const generatedFile = new FileLoader(data.data, file.name, false, this.getFileType(file.name));
      generatedFile.download();
    },
    async onClick() {
      if (this.files.length === 1) await this.downloadFile(this.files[0]);
      else this.isPopupVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.download-files {
  display: inline-block;
}
</style>
